import {Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'undefinedNumber'})
export class UndefinedNumberPipe implements PipeTransform {
    transform(value: number): string {
        return value ? value.toString() : '-';
    }
}
